export default __webpack_public_path__ + "static/media/i.5af645d2.png";